import React from 'react';

const Logo = ({ size = 'medium', showText = true, className = '' }) => {
  const sizes = {
    small: { width: '80px', height: '27px', fontSize: '8px' },
    medium: { width: '120px', height: '40px', fontSize: '10px' },
    large: { width: '180px', height: '60px', fontSize: '14px' }
  };

  const currentSize = sizes[size] || sizes.medium;

  return (
    <div className={`logo ${className}`} style={{ display: 'flex', alignItems: 'center' }}>
      <svg 
        width={currentSize.width} 
        height={currentSize.height} 
        viewBox="0 0 120 40" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Sun */}
        <circle cx="20" cy="15" r="8" fill="#FFD700" />
        <g stroke="#FFD700" strokeWidth="1" opacity="0.8">
          <line x1="20" y1="2" x2="20" y2="6" />
          <line x1="20" y1="24" x2="20" y2="28" />
          <line x1="7" y1="15" x2="11" y2="15" />
          <line x1="29" y1="15" x2="33" y2="15" />
          <line x1="11.86" y1="8.14" x2="14.64" y2="10.93" />
          <line x1="25.36" y1="19.07" x2="28.14" y2="21.86" />
          <line x1="11.86" y1="21.86" x2="14.64" y2="19.07" />
          <line x1="25.36" y1="10.93" x2="28.14" y2="8.14" />
        </g>
        
        {/* Waves */}
        <path 
          d="M0 25 Q10 20 20 25 T40 25 T60 25 T80 25 T100 25 T120 25" 
          stroke="#4A90E2" 
          strokeWidth="2" 
          fill="none" 
          opacity="0.7"
        />
        <path 
          d="M0 30 Q15 25 30 30 T60 30 T90 30 T120 30" 
          stroke="#4A90E2" 
          strokeWidth="1.5" 
          fill="none" 
          opacity="0.5"
        />
        
        {/* Beach/Sand */}
        <path 
          d="M0 32 Q30 28 60 32 T120 32 L120 40 L0 40 Z" 
          fill="#F4E4BC" 
          opacity="0.8"
        />
        
        {/* Text */}
        {showText && (
          <text 
            x="42" 
            y="18" 
            fontFamily="'Playfair Display', 'Georgia', serif" 
            fontSize={currentSize.fontSize} 
            fontWeight="bold" 
            fill="white"
          >
            Near the Beach
          </text>
        )}
      </svg>
    </div>
  );
};

export default Logo;
